export const state ={
    shippinglines: [],
    systemShippingline: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/shippinglines/state.js